import AppRecord from './AppRecord.js'

class EntityCostName extends AppRecord {
}

export default EntityCostName